import React, { useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  Typography,
  Divider,
  styled,
} from "@mui/material";
import Art from "../../resources/images/Art.jpg";
import M1 from "../../resources/images/Member1.jpg";
import M2 from "../../resources/images/Member2.jpg";
import SakshiGuptasImg from "../../resources/images/sakshi-gupta.png";
// import AOS from "aos";
// import "aos/dist/aos.css";

const Image = styled("img")``;
const AboutUs = () => {
  // useEffect(() => {
  //   AOS.init();
  // }, []);
  return (
    <Container
      maxWidth="xl"
      sx={{ pl: "0 !important", pr: "0 !important", my: 8 }}
    >
      <Box
        // data-aos="fade-up"
        sx={{
          px: {
            lg: 12,
            md: 8,
            sm: 4,
            xs: 2,
          },
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography
            fontWeight={400}
            fontFamily={"secondaryFontFamily"}
            sx={{
              fontSize: { xs: 28, sm: 40, md: 50, lg: 56 },
              lineHeight: {
                xs: "26px",
                sm: "38px",
                md: "48px",
                lg: "54px",
              },
            }}
            color={"#444444"}
          >
            Miraé: where perception meets precision, and every space tells a
            story.
          </Typography>
          <Typography
            mt={3}
            mb={"50px"}
            fontWeight={400}
            sx={{ fontSize: { xs: 16, sm: 18, md: 21, lg: 18 } }}
            maxWidth={1122}
            mx={"auto"}
          >
            At Miraé, we believe that dreams are meant to be realized, not fade
            into the distance. We partner with you to craft your unique
            narrative through our end-to-end design services. Your aspirations
            become the plot, your style the setting, and your life the story.
            <br />
            We blend the strength of architecture with the emotive power of
            interiors, crafting spaces that aren’t just designed, but felt.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 6,
            maxWidth: 1150,
            mx: "auto",
          }}
        >
          <Box flexShrink={0} display={"flex"} justifyContent={"center"}>
            <Image
              src={SakshiGuptasImg}
              alt="sakshi gupta image"
              sx={{
                width: { xs: "100%", sm: "350px", lg: "400px" },
                height: { xs: "auto", sm: "313px", lg: "360px" },
                objectFit: "cover",
              }}
            />
          </Box>
          <Box
            sx={{ display: "flex", flexDirection: "column", maxWidth: "630px" }}
          >
            <Typography fontSize={{ xs: 20 }} fontWeight={700}>
              My story is one of two worlds!
            </Typography>
            <Typography
              fontSize={{ xs: 20 }}
              fontWeight={400}
              mt={0.5}
              textAlign={{ xs: "justify", md: "left" }}
              color={"#716D64"}
            >
              My foundation! First, the disciplined world of architecture,
              forged in India. This foundation gave me a deep understanding of
              spatial integrity and structural possibility.
            </Typography>
            <Typography
              fontSize={{ xs: 20 }}
              mb={2}
              fontWeight={400}
              mt={0.5}
              textAlign={{ xs: "justify", md: "left" }}
              color={"#716D64"}
            >
              But my passion! The soul of space, the vibrant, expressive world
              of Italian design, discovered at DOMUS Academy in Milan, Italy. It
              was there, amidst the historic streets and avant-garde studios,
              that I learned to see space not just as a structure, but as a
              canvas for emotion and experience.
            </Typography>
            <Typography
              variant="h1"
              color={"#444444"}
              fontSize={{ xs: 50 }}
              fontFamily={"secondaryFontFamily"}
              lineHeight={"40px"}
              fontWeight={400}
            >
              Sakshi Gupta
            </Typography>
            <Typography variant="body2" fontWeight={400} color={"#AE4034"}>
              Architect & Interior Designer (Milan)
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default AboutUs;
